import { useRef, useState, useEffect } from 'react';

/**
 *
 * @param rootNode 监听img标签加载状态的根节点
 * @param deps 监听刷新的依赖
 * @returns 根节点下的所有img标签 是否都加载完成（无论加载是否成功）
 */
export default function useImgsLoadingCompleted(
  rootNode: React.RefObject<HTMLElement | null>,
  deps: React.DependencyList,
) {
  // 图片是否加载完成，键位图片src，值为是否加载中
  const imgLoadings = useRef<Map<HTMLImageElement, boolean>>(new Map());

  // 是否存在图片还在加载中
  const [imgLoading, setImgLoading] = useState(true);

  const handleLoaded = (e: any) => {
    const imgNode = e?.target;
    imgLoadings.current.set(imgNode, false);
    const imgLoading = Array.from(imgLoadings.current.values()).includes(true);
    setImgLoading(imgLoading);
  };

  useEffect(() => {
    const imgNodes = rootNode.current?.getElementsByTagName('img');
    if (!!imgNodes?.length) {
      for (const imgNode of imgNodes) {
        imgLoadings.current.set(imgNode, true);

        imgNode?.addEventListener('load', handleLoaded, false);

        imgNode?.addEventListener('error', handleLoaded, false);

        imgNode?.addEventListener('abort', handleLoaded, false);
      }
    }

    return () => {
      if (!!imgNodes?.length) {
        for (const imgNode of imgNodes) {
          imgNode?.removeEventListener('load', handleLoaded, false);

          imgNode?.removeEventListener('error', handleLoaded, false);

          imgNode?.removeEventListener('abort', handleLoaded, false);
        }
      }

      imgLoadings.current.clear();
      setImgLoading(true);
    };
  }, [deps]);

  return imgLoading;
}
